import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const CustomerSuccessDashboard = lazy(
    () => import("../components/CustomerSuccessDashboardContainer")
);

export const CustomerSuccessDashboardRoute: RouteObject = {
  path: "cs-dashboard",
  element: <CustomerSuccessDashboard />,
};

export default CustomerSuccessDashboardRoute;
